import React from 'react';
import { BrowserRouter, useLocation, useNavigate } from 'react-router';

import { LayoutAdmin } from '@/common/layout/admin';

/**
 * AI.GEN lines=1-20
 * 路由根组件 - 保留路由系统以便后续扩展
 */
const LayoutRoot = () => {
  const location = useLocation();
  const navigate = useNavigate();

  if (location.pathname === '/admin' || location.pathname === '/') {
    setTimeout(() => {
      navigate('/admin/order-manage');
    }, 0);

    return null;
  }
  if (location.pathname.startsWith('/admin')) {
    return <LayoutAdmin></LayoutAdmin>;
  }
  return null;
};

export const Router = () => {
  return (
    <BrowserRouter basename={'/'}>
      <LayoutRoot></LayoutRoot>
    </BrowserRouter>
  );
};
